import { message } from 'antd';

/** Handle common admin export JSON responses (url / async task / plain msg). */
export const handleExportResponse = (
    payload: { code?: number | string; data?: unknown; msg?: string },
    fallbackSuccessMsg: string,
) => {
    if (payload.code !== 200 && payload.code !== '200') {
        message.error(payload.msg || 'Export failed');
        return false;
    }

    const data = payload.data as any;
    const url =
        (typeof data === 'string' && /^https?:\/\//.test(data) && data) ||
        data?.download_url ||
        data?.url ||
        data?.file_url;

    if (typeof url === 'string' && url) {
        window.open(url, '_blank', 'noopener,noreferrer');
        message.success(payload.msg || fallbackSuccessMsg);
        return true;
    }

    message.success(payload.msg || fallbackSuccessMsg);
    return true;
};
